import { twMerge } from 'tailwind-merge';

import { ReactComponent as ArrowIcon } from 'assets/store/arrow.svg';

type ArrowProps = {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  iconClassName?: string;
};

export const Arrow = ({ direction, onClick, disabled = false, className = '', iconClassName = '' }: ArrowProps) => {
  const rotationClass = direction === 'right' ? '[transform:rotate(180deg)]' : '';
  const disabledClass = disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : 'tw-cursor-pointer hover:tw-opacity-80';

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={twMerge(
        'tw-flex tw-h-[30px] tw-w-[30px] tw-items-center tw-justify-center tw-border-none tw-bg-transparent tw-p-0 tw-transition-opacity tw-duration-200 lg:tw-h-[35px] lg:tw-w-[35px]',
        className,
        disabledClass
      )}
      aria-label={`Navigate ${direction}`}
    >
      <ArrowIcon
        className={twMerge(
          'tw-transition-transform tw-duration-200',
          rotationClass,
          iconClassName ? iconClassName : 'tw-h-[30px] tw-w-[30px] lg:tw-h-[35px] lg:tw-w-[35px]'
        )}
      />
    </button>
  );
};
